import tw, { styled } from 'twin.macro';
import { VideoContainer } from '../Video/Video.styles';

export const Container = styled.div`
  ${tw`fixed left-0 top-0`}
  ${tw`w-full h-full`}
  ${tw`z-[100]`}
  ${tw`overflow-hidden`}
  ${tw`bg-ui-colours-ui1/90`}
  ${tw`backdrop-blur-lg`}
`;

export const Wrapper = styled.div`
  ${tw`absolute right-1/2 bottom-1/2`}
  ${tw`transform translate-x-1/2 translate-y-1/2`}
  ${tw`w-[calc(100%-32px)] h-[150px]`}
  ${tw`sm:w-[400px] sm:h-[300px]`}
  ${tw`md:w-[600px] md:h-[450px]`}
  ${tw`lg:w-[928px] lg:h-[523px]`}
`;

export const Content = styled.div<{ hasPadding: boolean }>`
  ${tw`relative`}
  ${tw`sm:max-h-[300px]`}
  ${tw`md:max-h-[450px]`}
  ${tw`lg:max-h-[523px]`}
  

  ${({ hasPadding }) => hasPadding && tw`overflow-y-auto`}
  & section {
    ${({ hasPadding }) => hasPadding && tw`p-4 bg-neutrals-n1`}
  }

  // Customize video container in modal
  ${VideoContainer} {
    ${tw`rounded-xl`}
    ${tw`overflow-hidden`}
  }
`;
